// CustomerData.js
// UK & related scholarships – expanded dataset; dates from official sources (2025/2026 cycles). Check official sites for latest deadlines.

const CustomerData = [
  {
    id: 1,
    name: "Chevening Scholarships for Indian and International Students",
    startTime: "5 August 2025",
    endTime: "7 October 2025",
    price: "",
    action: "https://www.chevening.org/scholarship/india/",
    status: "Active",
  },
  {
    id: 2,
    name: "Rhodes Scholarships",
    startTime: "June 2025",
    endTime: "October 2025",
    price: "",
    action: "https://www.rhodeshouse.ox.ac.uk/scholarships/the-rhodes-scholarship/",
    status: "Active",
  },
  {
    id: 3,
    name: "Clarendon Fund (University of Oxford)",
    startTime: "Open",
    endTime: "December 2025 / January 2026 (course deadline)",
    price: "Full fees + living grant",
    action: "https://www.ox.ac.uk/clarendon",
    status: "Active",
  },
  {
    id: 4,
    name: "Commonwealth Scholarship and Fellowship",
    startTime: "Open now",
    endTime: "14 October 2025",
    price: "",
    action: "https://cscuk.fcdo.gov.uk/scholarships/",
    status: "Active",
  },
  {
    id: 5,
    name: "GREAT Scholarships",
    startTime: "September 2025",
    endTime: "Varies by university (2026/27 entry)",
    price: "Min. £10,000",
    action: "https://study-uk.britishcouncil.org/options/scholarships-financial-support/great-scholarships",
    status: "Active",
  },
  {
    id: 6,
    name: "Felix Scholarships (Oxford, Reading, SOAS)",
    startTime: "With graduate application",
    endTime: "e.g. SOAS 2 March 2026",
    price: "Full fees + living",
    action: "https://www.felixscholarship.org/",
    status: "Active",
  },
  {
    id: 7,
    name: "University of Birmingham India Postgraduate Scholarship",
    startTime: "Open",
    endTime: "31 May 2026",
    price: "£10,000",
    action: "https://www.birmingham.ac.uk/international/students/fees-and-funding/scholarships",
    status: "Active",
  },
  {
    id: 8,
    name: "University of Bristol Think Big Scholarships",
    startTime: "Open",
    endTime: "10 April 2026",
    price: "Up to £26,000 (tuition)",
    action: "https://www.bristol.ac.uk/international/fees-finance/scholarships/",
    status: "Active",
  },
  {
    id: 9,
    name: "Marshall Scholarships (US citizens only)",
    startTime: "Late spring 2026",
    endTime: "September 2026 (2027 cycle)",
    price: "Fees, living, travel",
    action: "https://marshallscholarship.org/apply/",
    status: "Archived",
  },
  {
    id: 10,
    name: "Erasmus Mundus",
    startTime: "October",
    endTime: "January",
    price: "",
    action: "https://eacea.ec.europa.eu/erasmus-plus/scholarships_en",
    status: "Archived",
  },
  {
    id: 11,
    name: "Scotland's Saltire Scholarships",
    startTime: "Check website",
    endTime: "TBC",
    price: "",
    action: "https://www.scotland.org/study/saltire-scholarships",
    status: "Archived",
  },
  {
    id: 12,
    name: "Charles Wallace India Trust Scholarships",
    startTime: "October",
    endTime: "January",
    price: "",
    action: "https://www.wallace-trusts.org.uk/india/",
    status: "Archived",
  },
  {
    id: 13,
    name: "Hornby Scholarships",
    startTime: "September",
    endTime: "March",
    price: "",
    action: "https://www.teachingenglish.org.uk/hornby-educational-trust",
    status: "Archived",
  },
  {
    id: 14,
    name: "Inlaks Scholarships",
    startTime: "15 February 2026",
    endTime: "31 March 2026",
    price: "",
    action: "https://www.inlaksfoundation.org/",
    status: "Active",
  },
];

export default CustomerData;
